import React from "react";
import KonfHubLogo from "../../../assets/logos/konfhub-logo.svg";
// iOS keyboard is now handled via CSS dvh units and viewport meta tag

const AuthLayout = ({ children, className = "", showLogo = true }) => {
  return (
    <div className={`auth-layout ${className}`}>
      <div className="auth-layout__container">
        {showLogo && (
          <div className="auth-layout__logo">
            <img src={KonfHubLogo} alt="KonfHub" />
          </div>
        )}
        <div className="auth-layout__content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
